import 'slick-carousel';

export default {
    init() {
        if ($('.logo_slideshow').length) {
            $('.logo_slideshow').each(function() {
                $(this)
                    .children('ul')
                    .slick({
                        autoplay: false,
                        arrows: true,
                        fade: false,
                        autoplaySpeed: 5000,
                        speed: 500,
                        infinite: false,
                        prevArrow: $('.logo_slideshow--left'),
                        nextArrow: $('.logo_slideshow--right')
                    });
            });
        }
    }
};
